var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2734 5.41667C11.2734 4.22005 12.2435 3.25 13.4401 3.25C14.6367 3.25 15.6068 4.22005 15.6068 5.41667C18.142 6.61543 19.8086 9.11543 19.9401 11.9167V15.1667C20.1054 16.5325 20.9096 17.7387 22.1068 18.4167H4.77344C5.97064 17.7387 6.77477 16.5325 6.9401 15.1667V11.9167C7.07159 9.11543 8.73825 6.61543 11.2734 5.41667",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1875 18.4165V19.4998C10.1875 21.2948 11.6426 22.7498 13.4375 22.7498C15.2324 22.7498 16.6875 21.2948 16.6875 19.4998V18.4165",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.7859fef1de57e43174d9267dfb28c964.svg";
export { ForwardRef as ReactComponent };